<div class="feedback-hints" *ngIf="showSettings.any">
  <div class="has-span" *ngIf="showSettings.favourite" [class.red]="is_liked">
    <app-svg src="/assets/icons/heart-filled.svg"></app-svg>
    <span>{{ likes }}</span>
  </div>

  <div class="green" *ngIf="showSettings.approved">
    <app-svg src="/assets/icons/flag-check.svg"></app-svg>
  </div>

  <div class="red" *ngIf="showSettings.rejected">
    <app-svg src="/assets/icons/flag-cross-outline.svg"></app-svg>
  </div>

  <div class="{{ color_label }}" *ngIf="showSettings.color_label">
    <app-svg src="/assets/icons/tag-filled.svg"></app-svg>
  </div>

  <div class="has-span" *ngIf="showSettings.comment">
    <app-svg src="/assets/icons/comment-dots.svg"></app-svg>
    <span>{{ text_comments_total_count + annotation_comments_total_count }}</span>
  </div>
</div>
